'use es6';

import { createAppStatusSelector } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { getIsUngatedForOneRouteUI } from 'EmailEditorUI/redux/selectors/AuthSelectors';
export const getParentCaresAboutNextIframeClick = createAppStatusSelector('caresAboutNextIframeClick');
export const getIsLayoutBuilderVisible = basicSelector(state => state.panesVisitStatus.currentPane === 'content' || getIsUngatedForOneRouteUI(state));